import { render } from "./Header.vue?vue&type=template&id=c80cf496&scoped=true"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=c80cf496&scoped=true&lang=scss"

import exportComponent from "/usr/share/nginx/production/goodedition/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c80cf496"]])

export default __exports__